import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { TextField } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { "app-setting": highlightedAppSettingIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedAppSettingIds.includes(id)) return "modifyResource";
    return "";
  };
  return (
    <ResponsiveList
      {...props}
      perPage={10}
      type="table"
      split
      filters={<Filters />}
      key={highlightedAppSettingIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="app-setting"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="key" />
        <TextField source="description" />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
